<template>
  <v-container fluid>
    <v-container fluid py-0>
      <v-row justify="end"
        ><v-switch
          label="Grid"
          v-model="grid"
          dense
          hide-details
          class="mr-2"
        ></v-switch
        ><v-switch
          v-if="grid"
          label="Grouped"
          v-model="grouped"
          dense
          hide-details
        ></v-switch>
      </v-row>
    </v-container>
    <v-row v-if="grid && !grouped">
      <v-col>
        <increments-table
          v-model="increments"
          @details="onShowIncrementDetails"
          @delete="onDelete"
        ></increments-table>
      </v-col>
    </v-row>
    <v-row v-if="grid && grouped">
      <v-col>
        <grouped-increments
          v-model="increments"
          :templateItems="templateItems"
          :department="department"
          :destination="destination"
        ></grouped-increments>
      </v-col>
    </v-row>
    <v-row v-if="!grid">
      <v-col>
        <v-expansion-panels
          multiple
          v-model="panels"
          v-if="increments.length > 0"
        >
          <v-expansion-panel v-for="inc in increments" :key="inc.id">
            <v-expansion-panel-header class="title">
              {{ inc.date | formatDate }} - Min Pax: {{ inc.minPax }}, Max Pax:
              {{ inc.maxPax }}
              {{ inc.paxTo }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <increment
                :increment="inc"
                :templateItems="templateItems"
                :department="department"
                :destination="destination"
                @update="onUpdateIncrement"
                @delete="onDelete"
                :template-id="templateId"
                for-adults
              ></increment>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <v-row>
      <add-btn
        label="Add Increments"
        icon="mdi-ballot"
        @click="onAddNewIncrement"
      ></add-btn>
    </v-row>
    <add-increment-dialog
      v-model="newIncrement"
      :show="showAddIncrement"
      :departures="departures"
      @close="showAddIncrement = false"
      @add="onAddIncrement"
      :templateItems="templateItems"
    ></add-increment-dialog>
    <basic-dialog
      :show="showIncrementDetails"
      @close="showIncrementDetails = false"
    >
      <template v-slot:title>{{
        selectedIncrement
          ? `${$options.filters.formatDate(
              selectedIncrement.date
            )} - Min Pax: ${selectedIncrement.minPax}, Max Pax: ${
              selectedIncrement.maxPax
            }`
          : "Increment Details"
      }}</template>
      <increment
        :increment="selectedIncrement"
        :templateItems="templateItems"
        :destination="destination"
        @update="onUpdateIncrement"
        @delete="onDelete"
        :template-id="templateId"
        for-adults
      ></increment>
    </basic-dialog>
    <v-row v-if="debug">
      <v-col>
        <code>{{ increments }}</code>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import gql from "graphql-tag";
import AddBtn from "../../../shared/AddBtn";
import AddIncrementDialog from "./AddIncrementDialog";
import Increment from "./Increment";
import { removeGQLTypename } from "../../../../../helpers";
import IncrementsTable from "./IncrementsTable";
import BasicDialog from "../../../shared/BasicDialog";
import GroupedIncrements from "./GroupedIncrements.vue";

const CREATE_INCREMENTS = gql`
  mutation createIncrements($id: ID!, $input: [TemplateIncrementInput!]!) {
    createTemplateIncrements(id: $id, input: $input) {
      id
      date
      step
      minPax
      maxPax
      adjustments {
        edges {
          node {
            id
            paxFrom
            paxTo
            adjustment1
            adjustment2
            adjustment3
            adjustment4
            foc1
            foc2
            foc3
            foc4
          }
        }
      }
    }
  }
`;
const INCREMENTS = gql`
  query templateIncrements($id: ID) {
    templateIncrements(id: $id) {
      edges {
        node {
          id
          uid
          reference
          date
          step
          minPax
          maxPax
          adjustments {
            edges {
              node {
                id
                paxFrom
                paxTo
                adjustment1
                adjustment2
                adjustment3
                adjustment4
                foc1
                foc2
                foc3
                foc4
              }
            }
          }
        }
      }
    }
  }
`;
const DELETE_INCREMENT = gql`
  mutation deleteIncrement($id: ID!) {
    deleteTemplateIncrement(id: $id) {
      id
    }
  }
`;
const UPDATE_INCREMENT = gql`
  mutation updateTemplateIncrement($input: TemplateIncrementInput!) {
    updateTemplateIncrement(input: $input) {
      id
    }
  }
`;
export default {
  name: "increments",

  props: {
    value: {
      type: Array,
      default: () => [],
    },
    templateItems: {
      type: Array,
      default: () => [],
    },
    templateId: {
      type: String,
      default: () => "",
    },
    departures: {
      type: Array,
      default: () => [],
    },
    department: {
      type: String,
      default: () => "FIT",
    },
    destination: {
      type: String,
      default: () => "",
    },
    duration: {
      type: Number,
      default: () => 0,
    },
  },

  components: {
    AddBtn,
    AddIncrementDialog,
    Increment,
    IncrementsTable,
    BasicDialog,
    GroupedIncrements,
  },

  data() {
    return {
      debug: false,
      grid: false,
      grouped: false,
      panels: [],
      showAddIncrement: false,
      skipLoad: true,
      newIncrement: {
        dates: [],
        minPax: 1,
        maxPax: 10,
        step: 2,
      },
      showIncrementDetails: false,
      selectedIncrement: null,
      //increments: [],
    };
  },

  computed: {
    increments() {
      return this.templateIncrements && this.templateIncrements.edges
        ? this.templateIncrements.edges.map(removeGQLTypename)
        : [];
    },
  },

  methods: {
    onShowIncrementDetails(payload) {
      this.selectedIncrement = { ...payload };
      this.showIncrementDetails = true;
    },
    onUpdateIncrement(payload) {
      this.$apollo
        .mutate({
          mutation: UPDATE_INCREMENT,
          variables: { input: payload },
          refetchQueries: [
            {
              query: INCREMENTS,
              variables: {
                id: this.templateId,
              },
            },
          ],
        })
        .then((res) => {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Increment Updated.",
          });
        })
        .catch((err) => {
          const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
          this.$store.dispatch("showAppSnackbar", {
            msg: errorMsg,
            color: "error",
          });
        });
    },
    onDelete(payload) {
      this.$apollo
        .mutate({
          mutation: DELETE_INCREMENT,
          variables: { id: payload.id },
          refetchQueries: [
            {
              query: INCREMENTS,
              variables: {
                id: this.templateId,
              },
            },
          ],
        })
        .then((res) => {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Increment Deleted.",
          });
          if (this.showIncrementDetails) {
            this.showIncrementDetails = false;
          }
        })
        .catch((err) => {
          const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
          this.$store.dispatch("showAppSnackbar", {
            msg: errorMsg,
            color: "error",
          });
        });
    },
    onAddNewIncrement() {
      this.showAddIncrement = true;
    },
    onIncrementChange(payload) {
      const editedIndex = this.increments.findIndex((i) => i.id == payload.id);
      if (editedIndex > -1) {
        Object.assign(this.increments[editedIndex], { ...payload });
      }
    },
    onAddIncrement(payload) {
      this.showAddIncrement = false;
      const increments = [];
      const { dates, ...inc } = payload;
      for (const date of dates) {
        increments.push({
          ...inc,
          date,
          notes: "",
        });
      }
      this.createIncrements(increments);
    },
    createIncrements(input) {
      this.$apollo
        .mutate({
          mutation: CREATE_INCREMENTS,
          variables: {
            id: this.templateId,
            input,
          },
          refetchQueries: [
            {
              query: INCREMENTS,
              variables: {
                id: this.templateId,
              },
            },
          ],
        })
        .then(({ data }) => {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Increments Created",
          });
        })
        .catch((err) => {
          const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
          this.$store.dispatch("showAppSnackbar", {
            msg: errorMsg,
            color: "error",
          });
        });
    },
  },

  apollo: {
    templateIncrements: {
      query: INCREMENTS,
      variables() {
        return { id: this.templateId };
      },
      skip() {
        return this.skipLoad;
      },
    },
  },

  mounted() {
    this.skipLoad = false;
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/templates/builder/increments/Increments.vue